import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onDelete", "icon", "inputSize"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Icon } from '@elements/icon';
import { StyledChip } from './chip.styles';
import CloseCircle from '@images/close-circle.svg';
import { jsx as _jsx } from "react/jsx-runtime";

var Chip = function Chip(_ref) {
  var onDelete = _ref.onDelete,
      icon = _ref.icon,
      inputSize = _ref.inputSize,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(StyledChip, _objectSpread(_objectSpread({}, restProps), {}, {
    withIcon: !!icon,
    withDelete: !!onDelete,
    icon: icon,
    onDelete: onDelete,
    deleteIcon: /*#__PURE__*/_jsx(Icon, {
      src: CloseCircle,
      width: inputSize === 'large' ? 24 : 20,
      height: inputSize === 'large' ? 24 : 20
    })
  }));
};

export { Chip };